import { Link } from 'react-router-dom';
import { statusClass, STATUS_LABEL } from '../../lib/accountCreationUi';
import { certificateTypeLabels } from '../../lib/certificateRequestSubmissions';
import type { ApplicationSubmission, CertificateRequestFormData } from '../../types/applicationForm';

type CertificateRequestListRowProps = {
  row: ApplicationSubmission;
  detailPath: string;
};

export function CertificateRequestListRow({ row, detailPath }: CertificateRequestListRowProps) {
  const data = row.form_data as CertificateRequestFormData;
  const itemNos = (data?.items ?? [])
    .map((item) => item.item_no.trim())
    .filter(Boolean)
    .join(', ');

  return (
    <Link to={detailPath} className="ctr-list-row">
      <span className="ctr-list-row__ref">{row.application_no}</span>

      <span className="ctr-list-row__company">
        <span className="ctr-list-row__company-name">{row.company_name || '—'}</span>
        {data?.customer_no ? (
          <span className="ctr-list-row__company-code">{data.customer_no}</span>
        ) : null}
      </span>

      <span className="ctr-list-row__text">{certificateTypeLabels(data)}</span>

      <span className="ctr-list-row__text ctr-list-row__text--items">{itemNos || '—'}</span>

      <span className="ctr-list-row__text">
        {data?.prepared_by?.trim() || row.authorised_by?.trim() || '—'}
      </span>

      <span className={statusClass(row.status)}>{STATUS_LABEL[row.status]}</span>

      <span className="ctr-list-row__chevron" aria-hidden>
        ›
      </span>
    </Link>
  );
}
